import { render, staticRenderFns } from "./ShopModelPlace.vue?vue&type=template&id=cf1adea8&scoped=true"
import script from "./ShopModelPlace.vue?vue&type=script&lang=js"
export * from "./ShopModelPlace.vue?vue&type=script&lang=js"
import style0 from "./ShopModelPlace.vue?vue&type=style&index=0&id=cf1adea8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf1adea8",
  null
  
)

export default component.exports